import { MessageResourceManager } from '../resources/message-resource-manager';
import { RootViewModel } from './root-view-model';
import { MetaDataUtils } from '../meta-data/meta-data-utils';
import type { ModelChangedEventArgsInterface, IdentityInterface, ModelInterface, InternalViewModelInterface, InternalRelationMetaDataInterface, InitInternalViewModelArguments } from '@nts/std/interfaces';
import { EventEmitter } from '@angular/core';

export class InternalRootViewModel<TModel extends ModelInterface<TIdentity>, TIdentity extends IdentityInterface>
    extends RootViewModel<TModel, TIdentity> implements InternalViewModelInterface {

    relationMetaData: InternalRelationMetaDataInterface;
    internalDomainModelChanged = new EventEmitter<ModelChangedEventArgsInterface<TModel>>();

    async initInternalViewModel({
        domainModel: domainModel,
        aggregateMetaData: metaData,
        orchestratorViewModel,
        relationMetaData,
        path,
        isMock = false,
        parent = undefined,
        domainModelType = undefined
    }: InitInternalViewModelArguments<TIdentity, TModel>): Promise<void> {

        this.reservedPath = path;
        this.reservedName = MetaDataUtils.toCamelCase(relationMetaData.principalPropertyName);
        this.relationMetaData = relationMetaData;
        this.isMock = isMock;
        this.parent = parent;

        await this.initAggregateElementViewModel({
            domainModel,
            aggregateMetaData: metaData,
            orchestratorViewModel,
            isMock,
            domainModelType
        });

        this.metadataShortDescription = orchestratorViewModel.useMessageResourceKey ?
            MessageResourceManager.Current.getMessageIfExists(
                relationMetaData.principalMetaData.descriptions.displayNameKey) : relationMetaData.principalMetaData.descriptions.displayName;

        this.metadataDescription = orchestratorViewModel.useMessageResourceKey ?
            MessageResourceManager.Current.getMessageIfExists(
                relationMetaData.principalMetaData.descriptions.descriptionKey) : relationMetaData.principalMetaData.descriptions.description;
    }
}
